function formatDate(date) {
    const res = new Date(date).toLocaleDateString();
    if(!date || res == "Invalid Date")
        return "";

    return res;
}

export default formatDate;